/* eslint-disable no-restricted-imports */
import { contentManifest } from '@/components/content/manifest';
import { ContentItem } from '@/data/types/LayoutAllSlots';
import { getContentNameFromWidgetName } from '@/data/utils/getContentNameFromWidgetName';
import { getLegacyContentNameFromWidgetName } from '@/utils/getLegacyContentNameFromWidgetName';

export const findElementByContentItem = (contentItem: ContentItem) => {
	const nameNormalized = getContentNameFromWidgetName(contentItem.name);
	let element = contentManifest[nameNormalized];

	if (!element) {
		const widgetName = getLegacyContentNameFromWidgetName(contentItem) ?? 'Unknown';
		element = contentManifest[widgetName];
	}

	return element;
};
